<template>
  <div class="px-2">
    <div class="py-2">
      <p class="ma-0 font-18 font-weight-medium text-gray-900">Detalhes do Produto por Lote</p>
      <p class="ma-0 font-13 text-gray-800">{{ props.produto.idproduto }} - {{ props.produto.descricao_produto }}</p>
    </div>

    <v-divider class="mb-1" />

    <v-layout>
      <v-flex xs6>
        <EstoquePorLote
          :produto="props.produto"
          :ponta_estoque_percentual="ponta_estoque_percentual"
          :cobertura_estoque="cobertura_estoque"
          :ponto_pedido="ponto_pedido"
        />
      </v-flex>

      <v-divider vertical class="ml-4" />

      <v-flex xs6>
        <AnalisePorCliente
          :produto="props.produto"
          :atualizar_por_desconsiderados="atualizar_por_desconsiderados"
          @updated:atualizar="$emit('updated:atualizar')"
          @updated:cobertura-estoque="cobertura_estoque = $event"
          @updated:ponto-pedido="ponto_pedido = $event"
          @updated:ponta-estoque-percentual="ponta_estoque_percentual = $event"
        />
      </v-flex>
    </v-layout>

    <v-divider class="my-2" />

    <ListagemDasVendas
      :produto="props.produto"
      :headers="headers"
      :items="items"
      height="calc(100vh - 584px)"
      hide-default-footer
      @consumos-desconsiderados="consumosDesconsiderados()"
    />
  </div>
</template>

<script setup>
import { logout } from "@/helpers";
import { onMounted, ref, watch } from "vue";
import Api from "@/api/api";
import ListagemDasVendas from "@/components/produto/detalhes/UltimasVendas/ListagemDasVendas/Index.vue";
import AnalisePorCliente from "./AnalisePorCliente.vue";
import EstoquePorLote from "./EstoquePorLote.vue";

const props = defineProps({
  produto: Object
});
const atualizar_por_desconsiderados = ref(0);
const ponta_estoque_percentual = ref(0);
const ponto_pedido = ref(0);
const cobertura_estoque = ref(0);
const headers = [
  { text: "ID Consumo", value: "idconsumo" },
  { text: "Data", value: "emissao" },
  { text: "Hora", value: "horariomov" },
  { text: "Cliente", value: "cliente" },
  { text: "Valor", value: "valor_unit" },
  { text: "Quantidade", value: "qtde" },
  { text: "Ações", value: "acoes" },
];

const items = ref([]);

watch(() => props.produto, buscarListagemDasVendas);

onMounted(buscarListagemDasVendas);

function consumosDesconsiderados() {
  atualizar_por_desconsiderados.value++;
  buscarListagemDasVendas();
}

function buscarListagemDasVendas() {
  const parametros = {
    idgrupo: props.produto.id_grupo,
    idproduto: props.produto.idproduto
  }

  Api
    .get('/compras/produtos/analise-por-lotes/buscar-listagem-das-vendas', { params: parametros })
    .then(response => items.value = response.data.items)
    .catch(logout);
}
</script>
